// Salesforce deep-link URL builder.
// Produces Lightning record URLs targeting the INNODIA org.
const SF_BASE = "https://innodia.lightning.force.com/lightning/r";

export type SfObject = "Contact" | "Opportunity" | "Account";

export function salesforceLink(objectType: SfObject, sfId: string): string {
  return `${SF_BASE}/${objectType}/${sfId}/view`;
}
